module.exports = __webpack_public_path__ + "static/media/DeleteGray.fddd92b4.svg";